import moment from 'moment-timezone';
import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Visitors Upsell Mirage Scenario
 * - `MIRAGE_SCENARIO=upsell yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server, options = {}) {
  const {
    company,
    subscription,
    locations: [location],
  } = visitorsClassicScenario(server, {
    withPlans: true,
    withSubscriptionPlans: true,
    withVisitorsLocationSubscription: true,
    withRoomsLocationSubscription: true,
  });

  // Setup basic Visitors subscription
  // https://envoy.help/en/articles/3330124-which-plan-should-our-company-choose#basic-plan
  const {
    plan = 'basic',
    subscribed = true,
    employeeLimit = '50',
    locationLimit = '1',
    onExpiredTrial = false,
  } = options;

  subscription.update({
    features: [],
    employeeLimit,
    locationLimit,
    onExpiredTrial,
    plan,
    subscribed,
    trialEndDate: moment().subtract(8, 'days').toDate(),
  });

  company.update({ planIntent: plan });
  location.update({ visitorsOnboardingComplete: true });

  // Setup scenario for upgrade plan banner to display
  const employeeCount = parseInt(employeeLimit, 10) + 1;
  server.createList('employee', employeeCount, { locationIds: [location.id] });

  // Setup payment source
  server.schema.paymentSources.create({
    brand: 'Visa',
    companyId: company.id,
    last4: 1234,
  });

  resetFixtures(server);
}

function resetFixtures(server) {
  const [SFLocation, NYLocation] = server.schema.locations.all().models;
  const [locationSubscription1, locationSubscription2] = server.schema.locationSubscriptions.all().models;
  server.schema.companies.first().update({ locationIds: [SFLocation.id] });
  SFLocation.update({ locationSubscriptionIds: [locationSubscription1.id] });
  NYLocation.destroy();
  locationSubscription2.destroy();
}
